module.exports = __webpack_public_path__ + "static/media/skm.ea3bca33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/skm.png
// module id = 1587
// module chunks = 0